<template lang="pug">
.breadcrumbs-container(ref="baseElement")
	nav.breadcrumbs(v-if="$breadcrumbs.length" :class="{ 'closed': !show }")
		.breadcrumb-home: i.fa.fas.fa-home
		transition-group(name="open-right" tag="div" class="breadcrumb-items-container main-breadcrumb-items-container" ref="items")
			.breadcrumb-item(v-for="(crumb, key) in $breadcrumbs" :key="`${key}-breadcrumb`")
				router-link(:to="linkProp(crumb)" :title="'Jump to ' + crumbText(crumb)") {{ crumbText(crumb) }}
		.breadcrumb-items-container
			button.breadcrumbs-toggle-button.right(@click="show = !show" :title="(show ? 'Hide' : 'Show') + ' Navigation Breadcrumbs'")
				i.fa.fas.fa-angle-double-left(v-show="show")
				i.fa.fas.fa-angle-double-right(v-show="!show")
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import MutationTypes from "@/store/mutation-types";

export default {
	computed: {
		show: {
			get() {
				return this.$store.getters.breadcrumbsOpened;
			},
			set(val) {
				this.$store.commit(MutationTypes.SET_BREADCRUMBS_OPENED, val);
			}
		}
	},
	watch: {
		$breadcrumbs() {
			Vue.nextTick(() => {
				/*
				if (this.$el && this.$el.children && this.$el.children[0])
					this.$el.children[0].scrollLeft = 100000;
				*/
			});
		}
	},
	mounted() {},
	methods: {
		replaceParamsInPath(path, params) {
			return _.reduce(
				params,
				(path, value, key) => {
					return path.replace(":" + key, value);
				},
				path
			);
		},
		linkProp(crumb) {
			// console.log(crumb);
			let ret = {};
			if (crumb.name || (crumb.handler && crumb.handler.name)) {
				ret = {
					// path: this.$route.path,
					name: crumb.name || crumb.handler.name,
					params: this.$route.params
				};
			} else {
				ret = {
					path: this.replaceParamsInPath(
						crumb.handler && crumb.handler.fullPath
							? crumb.handler.fullPath
							: crumb.path,
						this.$route.params
					),
					params: this.$route.params
				};
			}
			if (typeof crumb.meta.breadcrumb === "function" && ret.path) {
				let r = new RegExp(":[a-zA-Z0-9-+_]+");
				let matches = ret.path.match(r);
				if (_.isEmpty(matches)) return ret;
				ret.path =
					ret.path.substring(0, matches.index) +
					this.$route.params[matches[0].substring(1)];
			}
			return ret;
		},
		crumbText(crumb) {
			if (crumb.meta.title) {
				return crumb.meta.title;
			} else if (typeof crumb.meta.breadcrumb == "function") {
				return crumb.meta.breadcrumb.call(this);
			} else {
				return crumb.meta.breadcrumb;
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
.breadcrumbs
	position absolute
	top 1em
	left 1em
	background $t-very-light-bg-color
	border-radius .5rem
	display flex
	justify-content space-between
	align-items center
	box-shadow 0 0.1em 0.1em rgba(0, 0, 0, 0.3)
	transition all 0.2s ease

	&::-webkit-scrollbar
		display none

.breadcrumb-items-container
	display flex

	&:last-of-type
		min-width 3em
		padding-right 0.5em

.breadcrumb-home
	padding-left 1em

.main-breadcrumb-items-container
	margin-right auto

.breadcrumbs-toggle-button
	display flex
	min-width 2.5em
	width 2.5em
	height 2.5em
	border-radius .3rem
	justify-content center
	align-items center
	background none
	border 0
	cursor pointer
	transition all 0.2s ease
	outline 0
	color #111

	&:hover
		color #333
		background #eee

	&:active, &:focus
		background $brand-color
		color $dark-bg-text-color

.breadcrumbs
	overflow-y hidden
	white-space nowrap
	right 1em

	@media screen and (max-width: 600px)
		font-size 1.2rem

	.right
		margin-left auto

	.breadcrumb-item
		display flex
		align-items center
		position relative

		&~ .breadcrumb-item
			margin-left 1em

		&~ .breadcrumb-item::before
			font-family "Font Awesome 5 Free"
			font-weight 900
			content '\f105'
			position absolute
			left -0.7em
			display block

		router-link, a
			display block
			padding 1em 0.5em
			color $brand-color

	transition transform .2s ease-in-out
	&.closed
		transform translateX(-100%) translateX(2.5em)

.open-right-enter-active, .open-right-leave-active
	transform-origin 0% 100%
	transition all 0.2s ease

.open-right-enter, .open-right-leave-to
	transform scaleY(0)
</style>
